<template>
  <Modal title="编辑用户信息" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
      <Form ref="adminUserInfo"  :model='adminUserInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <form-item label="账号" prop="account" v-if="adminUserInfo.is_service==1">
          <Input placeholder="请输入账号" v-model="adminUserInfo.account" disabled></Input>
        </form-item>
        <form-item label="账号" prop="account" v-else>
          <Input placeholder="请输入账号" v-model="adminUserInfo.account"></Input>
        </form-item>

        <form-item label="密码" prop="password">
          <Input placeholder="请输入密码,不填则更改" type="password" password  v-model="adminUserInfo.password"></Input>
        </form-item>
        <form-item label="确认密码" prop="repwd">
          <Input placeholder="请输入确认密码,不填则更改" type="password" password  v-model="adminUserInfo.repwd"></Input>
        </form-item>
        <form-item label="昵称" prop="nickname">
          <Input placeholder="请输入昵称" v-model="adminUserInfo.nickname"></Input>
        </form-item>
        <FormItem label="头像：">
          <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
            <template v-if="item.status === 'finished'">
              <img :src="server_url+ item.url">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload
            v-if="uploadList.length==0"
            ref="uploadThumb"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            type="drag"
            :action="serverApiPic"
            style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>

          <Modal title="查看" v-model="visible">
            <img :src="server_url + imgUrl " v-if="visible" style="width: 100%">
          </Modal>
        </FormItem>
        <FormItem label="角色：" prop="role_id">
          <Select class="perW50"  v-model="adminUserInfo.role_id">
            <Option
              v-for="item in roleSelect"
              :value="item.role_id"
              :key="item.role_id"
            >{{item.role_name }}</Option
            >
          </Select>
        </FormItem>

        <form-item label="状态" prop="status">
          <RadioGroup v-model="adminUserInfo.status">
            <Radio :label="1" class="radio">启用</Radio>
            <Radio :label="2">禁用</Radio>
          </RadioGroup>
        </form-item>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" @click="handleOk('adminUserInfo')"  :loading="loading">
        <span v-if="!loading">提交</span>
        <span v-else>提交中...</span>
      </Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { groupAll, addAdminUser, adminuserInfo } from '@/api/admin'
import Setting from '@/setting'
export default {
  name: 'userEdit',
  props: ['id'],
  data () {
    return {
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      isShow: false,
      userid: 0,
      roleSelect: [],
      uploadList: [], // 缩咯图
      imgUrl: '',
      visible: false,
      loading: false,
      adminUserInfo: {
        id: 0,
        role_id: 0,
        account: '',
        avatar: '',
        nickname: '',
        status: 1,
        delpics: [] // 服务器待删除的照片
      },
      ruleValidate: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: '请选择角色', trigger: 'change', type: 'number' }
        ]
      }
    }
  },
  watch: {
    id (val) {
      this.userid = val
      if (this.userid > 0) {
        this.userInfo()
      }
    }
  },
  created () {
    this.getRole()
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    handleOk (name) {
      if (this.uploadList.length <= 0) {
        this.$Message.error('头像必填')
        return
      }
      this.adminUserInfo.avatar = this.uploadList[0]['url']
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          addAdminUser(this.adminUserInfo).then(res => {
            let msg = '添加成功'
            if (this.adminUserInfo.id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$emit('updateStatusModel')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
            this.loading = false
          })
        }
      })
    },
    userInfo () {
      if (this.userid) {
        adminuserInfo(this.userid).then(res => {
          this.adminUserInfo = res.data
          this.adminUserInfo.role_id = parseInt(res.data.role_id)
          this.uploadList.push({ 'url': this.adminUserInfo.avatar, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      console.log(this.adminUserInfo)
      const fileList2 = this.uploadList
      this.adminUserInfo.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      file.url = res.data.file_url
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于2M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    // 获取所有角色
    getRole () {
      groupAll().then(res => {
        this.roleSelect = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
